<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmedit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Type:</label>
	<input
		[disabled]="IsLoading() == true"
		type="text"
		maxlength="50"
		class="form-control"
		[(ngModel)]="VisitorTypeDesc"
		placeholder="Enter name of Visitor Type"
		style="width: 360px"
	/>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Update</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning leftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
